import { NoRowsOverlay } from '@shared/components';

export default function AddQuestionListNoRowsOverlay() {
  return <NoRowsOverlay title='ไม่พบข้อมูลที่ตรงกับการค้นหา' />;
}
